import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'

export const IntegrationsMobileTopBar = () => {
  const theme = useHeaderTheme()

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center />
      <MobileTopBarContainer.Right />
    </MobileTopBarContainer.Root>
  )
}
